import {
    UserRegistrationOverviewResultsRestDto,
    UserRegistrationRuleOverviewRestDto
} from "@/api/pharma-auth-urr/models";

export class UserRegistrationOverviewResultsRestDtoModel implements UserRegistrationOverviewResultsRestDto {
    results: UserRegistrationRuleOverviewRestDto[];



    constructor() {
        this.results = [];
    }

    public static createWithDefaults(): UserRegistrationOverviewResultsRestDtoModel {
        return new this();
    }
}
